import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-554a3644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ds-skeleton-date" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DSDate',
  setup(__props) {

const calendarModel = ref(new Date().toISOString().substring(0, 10));

return (_ctx: any,_cache: any) => {
  const _component_q_calendar = _resolveComponent("q-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_calendar, {
      model: calendarModel.value,
      readonly: "",
      mini: "",
      bordered: "",
      class: "ds-skeleton-date__calendar"
    }, null, 8, ["model"])
  ]))
}
}

})